import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/index';
import { PICK_BATCH_ASSIGNEE } from '../../../../filters/constants';
import { messages } from './messages';

import type { CriteriaInformations, ExistingFiltersHelpers } from '../../../../pages/products-page/purchase-orders/filter-options/types';

export const PickBatchAssignee = {
  id: PICK_BATCH_ASSIGNEE,
  displayName: <FormattedMessage {...messages.pickBatchAssignee} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'PickBatchAssignedUserId',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  render: (criteriaInformations: CriteriaInformations, existingFiltersHelpers?: ExistingFiltersHelpers) => {
    if (!existingFiltersHelpers) {
      return null;
    }
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
};
